"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_SIZE = exports.DEFAULT_BACKGROUND_COLOR = void 0;
const style_1 = __importDefault(require("style"));
exports.DEFAULT_BACKGROUND_COLOR = style_1.default.Color.Gray.S200;
exports.DEFAULT_SIZE = style_1.default.Text.Size.Base;
